export default function GoogleTouchPointDefaultPage() {
    return <div></div>
}